/* eslint-disable max-len */
/* eslint-disable react/function-component-definition */
import React from 'react';

export default function UserAgreement() {
  return (
    <div className="grid items-start gap-y-8 flex-1 mx-16 my-12 text-sm/normal text-left font-sans tracking-normal">
      <h1 className="text-3xl font-bold text-center">Информированное согласие пользователя сайта</h1>
      <div className="flex flex-col gap-6">
        <p>
          Настоящее согласие определяет условия и порядок обработки персональных данных пользователя сайта «A2Soft» (далее —
          Пользователь), расположенного на доменном имени
          {' '}
          <a
            className="text-blue-500 hover:text-blue-600"
            href="https://a2soft.ru/"
          >
            <span>https://a2soft.ru/</span>
          </a>
          {' '}
          (в т.ч. поддоменов), принадлежащего Обществу с ограниченной ответственностью «А2Софт» (далее — Сайт).
          <br />
          <br />
          Проставляя «галочку» в поле «Я принимаю политику обработки персональных данных» и указывая персональные данные на Сайте, Пользователь выражает согласие с условиями обработки персональных данных Обществом с ограниченной
          ответственностью «А2Софт» (далее — Общество), находящимся по адресу: г. Казань, улица Тукая, д.23, офис 217, Казань, 420021,
          и подтверждает, что:
          {' '}
          <br />
          • все указанные им данные принадлежат лично ему;
          <br />
          • является совершеннолетним;
          <br />
          • он действует свободно, своей волей и в своем интересе;
          <br />
          • им внимательно и в полном объеме прочитано настоящее согласие и политика обработки персональных данных, и данные
          документы ему понятны;
          <br />
          • вправе обращаться от имени компании, для которой запрашивает информацию о деятельности Общества.
          <br />
          <br />
          Пользователь выражает свое согласие на обработку его персональных данных, а именно совершение любых действий или
          совокупности действий, совершаемых с использованием средств автоматизации или без использования таких средств с
          персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение),
          извлечение, использование, блокирование, удаление, уничтожение персональных данных.
          <br />
          <br />
          Передача персональных данных Пользователя третьим лицам не осуществляется, за исключением лиц, осуществляющих
          обработку персональных данных по поручению Общества и от его имени, а также случаев, установленных законодательством.
          <br />
          <br />
          Общество осуществляет обработку, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение),
          извлечение персональных данных граждан Российской Федерации с использованием баз данных, находящихся на территории
          Российской Федерации, если иное не предусмотрено требованиями законодательства РФ.
          <br />
          <br />
          Пользователь дает согласие на обработку Обществом персональных данных для цели получения информации о деятельности и
          мероприятиях Общества, последующего проведения переговоров и заключения договора между Обществом и компанией, которую
          представляет Пользователь.
          <br />
          <br />
          Персональные данные, которые обрабатываются Обществом для достижения цели согласия:
          <br />
          • фамилия, имя, отчество;
          <br />
          • должность;
          <br />
          • наименование компании, от лица которой действует Пользователь;
          <br />
          • адрес электронной почты;
          <br />
          • телефон;
          {' '}
          <br />
          • фотография.
          <br />
          <br />
          Согласие Пользователя на обработку персональных данных является предметным, конкретным, информированным и
          сознательным.
          <br />
          <br />
          Настоящее согласие на обработку персональных данных действует до достижения цели настоящего согласия, если иной срок
          обработки не следует из требований законодательства РФ.
          <br />
          <br />
          Общество обязуется принимать все необходимые меры для защиты персональных данных Пользователя, предусмотренные
          действующим законодательством в области защиты персональных данных и соблюдать конфиденциальность таких данных.
          <br />
          <br />
          Настоящее согласие на обработку персональных данных может быть отозвано путем направления заявления по электронному
          адресу
          {' '}
          <a
            className="text-blue-500 hover:text-blue-600"
            href="mailto:info@a2soft.ru"
          >
            <span>info@a2soft.ru</span>
          </a>
          {' '}
          или в письменной форме почтовым отправлением по адресу: 420021, г. Казань, улица Тукая, д.23, офис 217. Для
          осуществления отзыва согласия Пользователь обязан указать фамилию, имя, отчество, должность и наименование компании,
          от лица которой он действует.
          <br />
          <br />
          При несогласии с любым указанным в согласии положением Пользователь обязан отказаться от совершения действий на Сайте,
          для которых требуется использование Обществом его персональных данных.
          <br />
          <br />
          Общество разъясняет, что последствия отказа предоставления персональных данных Пользователем, заключаются в
          невозможности предоставления дополнительной информации о деятельности Общества Пользователю и, как следствие,
          невозможности проведения переговоров с компанией, которую Пользователь представляет для заключения договора. В таком
          случае Пользователь вправе инициировать направление официального письменного запроса о предоставлении информации на
          электронную почту Общества
          {' '}
          <a
            className="text-blue-500 hover:text-blue-600"
            href="mailto:info@a2soft.ru"
          >
            <span>info@a2soft.ru</span>
          </a>
          <span>.</span>
        </p>
        {' '}
      </div>
    </div>
  );
}
